import { render, staticRenderFns } from "./satisfaction.vue?vue&type=template&id=201fbf5a&scoped=true"
import script from "./satisfaction.vue?vue&type=script&lang=js"
export * from "./satisfaction.vue?vue&type=script&lang=js"
import style0 from "./satisfaction.vue?vue&type=style&index=0&id=201fbf5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201fbf5a",
  null
  
)

export default component.exports